import { defu } from 'defu'

// Fix to convert the theme config vars to kebab case
function convertCssVarsToKebabCase(themeConfig: ThemeConfig) {
  if (!themeConfig.cssVariables) return themeConfig

  const convertedCssVars = Object.fromEntries(
    Object.entries(themeConfig.cssVariables || {}).map(([key, value]) => [useSnakeCase(key).replaceAll('_', '-'), value]),
  )
  return {
    ...themeConfig,
    // the fetch util automatically converts keys to camelcase, so we need to do the reverse here
    cssVariables: convertedCssVars,
  }
}

// Before initial page load:
// 1) Load the theme config from the center profile
// 2) Convert it to kebab case
// 3) Apply it
export default defineNuxtRouteMiddleware(async (to, from) => {
  // console.log('[load-center-theme] 🏰 Loading center theme...')
  // if (import.meta.client) return

  // This should've been fetched by the 2.preload.global.ts previous middleware
  const { currentCenterProfile } = await useCurrentCenter()

  // Preload and apply (partially) the theme config
  const { themeConfig } = useThemeConfig()
  const appConfig = useAppConfig()
  if (currentCenterProfile.value?.themeConfig) {
    // Merge with the existing theme config in case some values are not set in the custom config
    // For example: if no css variables are set, we use the default ones from the app config
    themeConfig.value = defu(
      convertCssVarsToKebabCase(currentCenterProfile.value?.themeConfig),
      appConfig.theme as ThemeConfig,
    )
    // console.log('[load-center-theme] 🏰 Merged theme config:', themeConfig.value)
  }
  else {
    console.warn('[load-center-theme] 🏰 No theme config found')
  }
  const { applyThemeConfig } = useTheme()
  applyThemeConfig(themeConfig.value)
})
